import styled from 'styled-components'

const HeaderDisclaimerText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: ${props => props.theme.fontSizeMedium};
  font-family: ${props => props.theme.fontFamily};
  color: ${props => props.theme.textColorPrimary};
  margin-bottom: 20px;
`

export default HeaderDisclaimerText
